import * as z from "zod";

export const categoryFormSchema = z.object({
  name: z.string().min(1, "Category name is required"),
  color: z.string().min(1, "Color is required"),
  parent: z.number().min(0, "Category parent is required"),
});

export type CategoryFormValues = z.infer<typeof categoryFormSchema>;
